import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row bt-dash" }
const _hoisted_2 = { class: "col-6" }
const _hoisted_3 = { class: "d-flex align-items-center gap-3 form-check checkbox-checked my-3" }
const _hoisted_4 = { class: "col-12 p-0 bt-dash" }
const _hoisted_5 = {
  class: "w-100 table",
  style: {"border-collapse":"collapse"}
}
const _hoisted_6 = { class: "d-flex justify-content-center align-items-center gap-2 form-check checkbox-checked" }
const _hoisted_7 = {
  for: `checkbox-source-variable`,
  style: {"margin-top":"12px"}
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "d-flex justify-content-center align-items-center gap-2 form-check checkbox-checked" }
const _hoisted_10 = ["id", "onUpdate:modelValue"]
const _hoisted_11 = ["for"]
const _hoisted_12 = ["disabled", "onClick"]
const _hoisted_13 = ["disabled", "onClick"]
const _hoisted_14 = ["disabled", "onClick"]

import { ref, defineAsyncComponent, onMounted, reactive, computed, watch } from 'vue';
import { useProductsStore } from '@/store/management/productsStore';
import type { VariationItem, Product } from '@/store/management/productsStore';
import Swal from 'sweetalert2';


export default /*@__PURE__*/_defineComponent({
  __name: 'productVariation',
  setup(__props) {

const productSearchModal = defineAsyncComponent(() => import('@/components/managementPages/productsPage/productSearchModal.vue'));
const productStore = useProductsStore()

const variationTemplate = ref([
    {
        selected: false,
        id: '2',
        variation: 'S/R',
        productData: {} as Product
    },
    {
        selected: false,
        id: '3',
        variation: 'L',
        productData: {} as Product
    },
    {
        selected: false,
        id: '4',
        variation: 'XL',
        productData: {} as Product
    },
])

watch(
    () => variationTemplate.value.map(v => v.selected),
    (newVal, oldVal) => {
        newVal.forEach((selected, index) => {
            const variation = variationTemplate.value[index];
            if (selected && !oldVal[index]) {
                compState.variationItem.push({
                    id: variation.id,
                    variation: variation.variation,
                    productData: variation.productData
                });
            } else if (!selected && oldVal[index]) {
                const itemIndex = compState.variationItem.findIndex(item => item.id === variation.id);
                if (itemIndex !== -1) {
                    compState.variationItem.splice(itemIndex, 1);
                }
            }
        });
    },
    { deep: true }
);

const compState = reactive({
    activeVariationID: '',
    required: false,
    sourceProduct: false,
    sourceProductData: {
        selected: false,
        id: '1',
        variation: 'Source',
        productData: {} as Product
    },
    variationItem: [] as VariationItem[],
})

const activeProduct = computed(() => {
    return productStore.getActiveProduct
})

const tempActiveProduct = computed(() => {
    return productStore.getTempActiveProduct
})

const activeProductId = computed(() => {
    return productStore.getActiveProductId
})

onMounted(() => {
    if (tempActiveProduct.value?.basic.productNumber) {
        const productGroup = tempActiveProduct.value
        const variationData = productGroup.variation
        compState.variationItem = variationData.variationItem
        compState.sourceProduct = variationData.sourceProduct
        compState.required = variationData.required
        variationTemplate.value.forEach((variation) => {
            variation.selected = !!variationData.variationItem.find(item => item.id === variation.id)
        })
        if (variationData.sourceProduct) {
            compState.sourceProductData.selected = true
            compState.sourceProductData.productData = tempActiveProduct.value
        } else {
            onClearSourceData()
        }
    }
})

const onProductSearchOpen = (activeVariationID: string) => {
    compState.activeVariationID = activeVariationID
}

const onSelect = (product: Product) => {
    const isProductAlreadySelected = variationTemplate.value.some(
        (variation) => variation.productData?.basic?.productNumber === product.basic.productNumber
    );

    if (compState.sourceProductData.productData.basic.productNumber === product.basic.productNumber) {
        Swal.fire({
            icon: 'warning',
            title: 'Warning',
            text: 'Cannot select source product.',
        });
        return;
    }

    if (!isProductAlreadySelected) {
        variationTemplate.value.forEach((variation) => {
            if (variation.id === compState.activeVariationID) {
                variation.productData = product;
                variation.selected = true;
            }
        });
    } else {
        Swal.fire({
            icon: 'warning',
            title: 'Warning',
            text: 'This product is already selected.',
        });
    }
}

const onClearSourceData = () => {
    compState.sourceProductData.productData = {} as Product
    compState.sourceProductData.selected = false
    compState.sourceProduct = false
    variationTemplate.value.forEach((variation) => {
        variation.productData = {} as Product
        variation.selected = false
    })
}

const onClearProductData = (variationID: string) => {
    variationTemplate.value.forEach((variation) => {
        if (variation.id === variationID) {
            variation.productData = {} as Product
            variation.selected = false
        }
    })
}

const onSourceClick = () => {
    compState.activeVariationID = compState.sourceProductData.id
    compState.sourceProduct = true
    compState.sourceProductData.productData = activeProduct.value
    compState.sourceProductData.selected = true
}

const canClearVariationData = (variationID: string) => {
    return variationTemplate.value.some(variation => variation.selected && variation.id === variationID);
}

watch(activeProductId, (newVal) => {
    if (newVal) {
        const productGroup = activeProduct.value
        const variationData = productGroup.variation
        compState.variationItem = variationData.variationItem
        compState.sourceProduct = variationData.sourceProduct
        compState.required = variationData.required
        if (variationData.sourceProduct) {
            compState.sourceProductData.selected = true
            compState.sourceProductData.productData = tempActiveProduct.value
        } else {
            onClearSourceData()
        }
    }
}, { immediate: true });

watch(compState, (newVal) => {
    productStore.setTempActiveProduct({
        ...tempActiveProduct.value,
        variation: {
            required: newVal.required,
            variationItem: newVal.variationItem,
            sourceProduct: newVal.sourceProduct
        }
    })

}, { deep: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: `checkbox-Required`,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((compState.required) = $event)),
              class: "form-check-input"
            }, null, 512), [
              [_vModelCheckbox, compState.required]
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("label", {
              for: `checkbox-Required`,
              style: {"margin":"0"}
            }, "Variation Required", -1))
          ]),
          _createElementVNode("button", {
            class: "btn btn-outline-primary-2x",
            type: "button",
            onClick: onSourceClick
          }, _cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "fa fa-info-circle" }, null, -1),
            _createTextVNode(" This is a source ")
          ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th"),
              _createElementVNode("th", null, "Variation"),
              _createElementVNode("th", null, "Product Number"),
              _createElementVNode("th", null, "Product Name"),
              _createElementVNode("th"),
              _createElementVNode("th")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: `checkbox-source-variable`,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((compState.sourceProduct) = $event)),
                    class: "form-check-input",
                    disabled: true
                  }, null, 512), [
                    [_vModelCheckbox, compState.sourceProduct]
                  ]),
                  _createElementVNode("label", _hoisted_7, _toDisplayString(compState.sourceProductData.id) + ".", 1)
                ])
              ]),
              _createElementVNode("td", null, _toDisplayString(compState.sourceProductData.variation), 1),
              _createElementVNode("td", null, _toDisplayString(compState.sourceProductData?.productData?.basic?.productNumber || 'N/A'), 1),
              _createElementVNode("td", null, _toDisplayString(compState.sourceProductData?.productData?.basic?.name || 'N/A'), 1),
              _cache[5] || (_cache[5] = _createElementVNode("td", null, null, -1)),
              _createElementVNode("td", null, [
                _createElementVNode("button", {
                  disabled: !compState.sourceProductData?.productData?.basic?.productNumber,
                  class: "btn btn-danger",
                  type: "button",
                  onClick: onClearSourceData
                }, _cache[4] || (_cache[4] = [
                  _createElementVNode("i", { class: "fa fa-times" }, null, -1),
                  _createTextVNode(" Clear ")
                ]), 8, _hoisted_8)
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variationTemplate.value, (variation) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: variation.id
              }, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: `checkbox-${variation.id}`,
                      "onUpdate:modelValue": ($event: any) => ((variation.selected) = $event),
                      class: "form-check-input",
                      disabled: true
                    }, null, 8, _hoisted_10), [
                      [_vModelCheckbox, variation.selected]
                    ]),
                    _createElementVNode("label", {
                      for: `checkbox-${variation.id}`,
                      style: {"margin-top":"12px"}
                    }, _toDisplayString(variation.id) + ".", 9, _hoisted_11)
                  ])
                ]),
                _createElementVNode("td", null, _toDisplayString(variation.variation), 1),
                _createElementVNode("td", null, _toDisplayString(variation?.productData?.basic?.productNumber || 'N/A'), 1),
                _createElementVNode("td", null, _toDisplayString(variation?.productData?.basic?.name || 'N/A'), 1),
                _createElementVNode("td", null, [
                  (variation?.productData?.basic?.productNumber)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        disabled: !compState.sourceProductData.selected,
                        class: "btn btn-secondary",
                        type: "button",
                        "data-bs-toggle": "modal",
                        "data-original-title": "test",
                        "data-bs-target": "#product-search-modal",
                        onClick: ($event: any) => (onProductSearchOpen(variation.id))
                      }, _cache[6] || (_cache[6] = [
                        _createElementVNode("i", { class: "fa fa-edit" }, null, -1),
                        _createTextVNode(" Edit ")
                      ]), 8, _hoisted_12))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        disabled: !compState.sourceProductData.selected,
                        class: "btn btn-primary",
                        type: "button",
                        "data-bs-toggle": "modal",
                        "data-original-title": "test",
                        "data-bs-target": "#product-search-modal",
                        onClick: ($event: any) => (onProductSearchOpen(variation.id))
                      }, _cache[7] || (_cache[7] = [
                        _createElementVNode("i", { class: "fa fa-plus" }, null, -1),
                        _createTextVNode(" Add ")
                      ]), 8, _hoisted_13))
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    disabled: !canClearVariationData(variation.id),
                    class: "btn btn-danger",
                    type: "button",
                    onClick: ($event: any) => (onClearProductData(variation.id))
                  }, _cache[8] || (_cache[8] = [
                    _createElementVNode("i", { class: "fa fa-times" }, null, -1),
                    _createTextVNode(" Clear ")
                  ]), 8, _hoisted_14)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createVNode(_unref(productSearchModal), { onOnSelect: onSelect })
  ], 64))
}
}

})